<div class="container">
  <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
          {{historyHead?.sensorDescription}}
        </h1>
      </div>
    </div>
  </section>
</div>

<div class="history-chart">
    @if (lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0) {
      <canvas baseChart
        [data]="lineChartData" [options]="lineChartOptions" [plugins]="chartPlugins" [type]="lineChartType" (chartHover)="chartHovered($event)"
        (chartClick)="chartClicked($event)">
      </canvas>
    }
  </div>
